import React, { useState, useRef, useEffect } from 'react';
import { message, Modal, Tabs } from 'antd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import moment from 'moment';
import { LocalPersistence } from '../../../../../factories';
import DetailDetails from './GuaranteePaymentDetails/DetailDetails';
import DetailEdit from './GuaranteePaymentEdit/DetailEdit';
import AcceptedPaymentDetails from './GuaranteePaymentDetails/AcceptedPaymentDetails';
import AcceptedPaymentEdit from './GuaranteePaymentEdit/AcceptedPaymentEdit';
import PaymentAddressDetails from './GuaranteePaymentDetails/PaymentAddressDetails';
import PaymentAddressEdit from './GuaranteePaymentEdit/PaymentAddressEdit';
import {
  delPolicyGuaranteePayment,
  putPolicyGuaranteePaymentAccPayment,
  putPolicyGuaranteePaymentAddress,
  putPolicyGuaranteePaymentDetails,
} from '../../../../../services/policy';
import Loading from '../../../../Loading';
import styles from './gpStyles.module.css';
const dateFormat = 'MM/DD/YYYY';
const formatTime = 'HH:mm';
const { TabPane } = Tabs;

const GPDetails = (props: any) => {
  const [rowEditData, setRowEditData] = useState(props.cancellationDetails);
  const [eidtFlag, setEditFlag] = useState(false);
  const [loadinFlag, setLoadinFlag] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState('Detail');
  const [disabledStatus, setDisabledStatus] = useState<boolean>(true);
  const [dateValidation, setDateValidation] = useState<boolean>(false);
  const toggleToEditMode = () => {
    props.isEditable();
    setEditFlag(true);
  };
  const detailEditRef = useRef<any>();
  const accPayEditRef = useRef<any>();
  const payAddEditRef = useRef<any>();

  const callSaveApi = async (value: any) => {
    const editObj: any = {};
    detailEditRef.current.dayValueList.forEach((item: any) => {
      editObj[item.label] = '' + item.value;
    });
    const detailsValue = value[0];
    editObj.startdate = detailsValue.startdate
      ? moment(detailsValue.startdate).format(dateFormat)
      : '';
    editObj.enddate = detailsValue.enddate
      ? moment(detailsValue.enddate).format(dateFormat)
      : '';
    editObj.policyname = detailsValue.policyname || '';
    editObj.policycode = detailsValue.policycode || '';
    editObj.policytype = detailsValue.policytype || '';
    editObj.guaranteetype = detailsValue.guaranteetype || '';
    editObj.roomtypecode = detailsValue.roomtypecode || '';
    editObj.nonrefundable = detailsValue.nonrefundable || '';
    editObj.holdtime =
      (detailsValue.holdtime &&
        moment(detailsValue.holdtime).format(formatTime)) ||
      '';
    editObj.retribution = detailsValue.retribution || '';
    editObj.chargetype = detailsValue.chargetype || '';
    if (editObj.chargetype === 'Amount') {
      editObj.chargeamount = detailsValue.charge || '';
      editObj.currency = detailsValue.currency || '';
    } else if (editObj.chargetype === 'Percent') {
      editObj.chargepercent = detailsValue.charge || '';
    } else if (editObj.chargetype === 'Nights') {
      editObj.chargenights = detailsValue.charge || '';
    }
    editObj.timeunit = detailsValue.timeunit || '';
    editObj.noofunits = detailsValue.noofunits || '';
    editObj.calculationmethod = detailsValue.calculationmethod || '';
    editObj.descriptions = [];
    Object.keys(detailsValue).forEach((item) => {
      item.indexOf('descript-') >= 0 &&
        editObj.descriptions.push({ text: detailsValue[item] || '' });
    });

    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();

    const paramsDetails = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
        policies: {
          guaranteepolicy: [
            {
              guaranteeid: props.cancellationDetails.guaranteeid,
              guaranteelangid: props.cancellationDetails.guaranteelangid,
              ...editObj,
            },
          ],
        },
      },
    };
    //const resDet = await putPolicyGuaranteePaymentDetails(paramsDetails);

    const accPayValue = value[1];
    let accPayArr: any = [];
    const accPayId = Object.keys(accPayValue).map((item) => {
      return item.split('-')[1];
    });
    Array.from(new Set(accPayId)).forEach((item) => {
      accPayArr.push({
        cardtype: accPayValue['cardtype-' + item] || '',
        acceptedforguarnatee: accPayValue['acceptedforguarnatee-' + item] || '',
        paymenttype: accPayValue['paymenttype-' + item] || '',
        description: accPayValue['description-' + item] || '',
        usefordeposit: accPayValue['usefordeposit-' + item] || '',
        useforpayment: accPayValue['useforpayment-' + item] || '',
      });
    });
    editObj.acceptedpayments = accPayArr;
    const paramsPayment = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
        policies: {
          guaranteepolicy: [
            {
              guaranteeid: props.cancellationDetails.guaranteeid,
              guaranteelangid: props.cancellationDetails.guaranteelangid,
              acceptedpayments: accPayArr,
            },
          ],
        },
      },
    };
    // const resAcc = await putPolicyGuaranteePaymentAccPayment(paramsPayment);

    const payAddValue = value[2];
    let payAddArr: any = [];

    const payAddId: any = [];
    const addressId: any = [];
    Object.keys(payAddValue).forEach((item) => {
      if (item.split('-')[1].indexOf('**') > 0) {
        addressId.push(item.split('-')[1]);
      } else {
        payAddId.push(item.split('-')[1]);
      }
    });

    Array.from(new Set(payAddId)).forEach((item) => {
      const addresslineArr: any = {};
      const addresslineId = addressId.filter((item1: any) => {
        return item1.startsWith(item + '**');
      });
      addresslineId.forEach((addId: any, index: number) => {
        addresslineArr['addressline' + (index + 1)] =
          payAddValue['address-' + addId];
      });
      payAddArr.push({
        name: payAddValue['addname-' + item] || '',
        type: payAddValue['type-' + item] || '',
        pobox: payAddValue['pobox-' + item] || '',
        city: payAddValue['city-' + item] || '',
        state: payAddValue['state-' + item] || '',
        country: payAddValue['country-' + item] || '',
        postalcode: payAddValue['postalcode-' + item] || '',
        ...addresslineArr,
      });
    });
    editObj.paymentaddress = payAddArr;

    const paramsAddress = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
        policies: {
          guaranteepolicy: [
            {
              guaranteeid: props.cancellationDetails.guaranteeid,
              guaranteelangid: props.cancellationDetails.guaranteelangid,
              paymentaddress: payAddArr,
            },
          ],
        },
      },
    };
    // const resAdd = await putPolicyGuaranteePaymentAddress(paramsAddress);
    setLoadinFlag(true);
    if (activeTabKey === 'Detail') {
      putPolicyGuaranteePaymentDetails(paramsDetails).then(
        (res) => {
          setLoadinFlag(false);
          if (res.result.success) {
            const filterData = res.property.policies.guaranteepolicy.filter(
              (item: any) => {
                return (item.guaranteeid =
                  props.cancellationDetails.guaranteeid && testGuaranteeLangId(item.guaranteelangid, props.cancellationDetails?.guaranteelangid));
              }
            );
            setRowEditData(filterData[0]);
            setEditFlag(false);
            props.cancelEditable();
          } else {
            message.error({
              content: 'operation failed',
            });
          }
        },
        (err) => {
          message.error({
            content:
              err?.message || err?.error[0]?.message || 'operation failed',
          });
          setLoadinFlag(false);
        }
      );
    } else if (activeTabKey === 'AcceptedPayment') {
      putPolicyGuaranteePaymentAccPayment(paramsPayment).then(
        (res) => {
          setLoadinFlag(false);
          if (res.result.success) {
            setRowEditData(editObj);
            setEditFlag(false);
            props.cancelEditable();
          } else {
            message.error({
              content: 'operation failed',
            });
          }
        },
        (err) => {
          message.error({
            content:
              err?.message || err?.error[0]?.message || 'operation failed',
          });
          setLoadinFlag(false);
        }
      );
    } else if (activeTabKey === 'PaymentAddress') {
      putPolicyGuaranteePaymentAddress(paramsAddress).then(
        (res) => {
          setLoadinFlag(false);
          if (res.result.success) {
            setRowEditData(editObj);
            setEditFlag(false);
            props.cancelEditable();
          } else {
            message.error({
              content: 'operation failed',
            });
          }
        },
        (err) => {
          message.error({
            content:
              err?.message || err?.error[0]?.message || 'operation failed',
          });
          setLoadinFlag(false);
        }
      );
    }
  };

  const testGuaranteeLangId = (r: any, r2: any) => {
    debugger
    if(r && r2) {
      return (r === r2)
    }else return !!(!r2 && r);

  }
  const addSave = () => {
    Promise.all([
      detailEditRef.current.detailsForm.validateFields(),
      accPayEditRef.current.aceeptedPaymentForm.validateFields(),
      payAddEditRef.current.paymentAddressForm.validateFields(),
    ])
      .then((value: Array<any>) => {
        callSaveApi(value);
      })
      .catch((err) => {
        let values = [
          detailEditRef.current.detailsForm.getFieldsValue(),
          accPayEditRef.current.aceeptedPaymentForm.getFieldsValue(),
          payAddEditRef.current.paymentAddressForm.getFieldsValue(),
        ];
        callSaveApi(values);
      });
  };

  const ModalHead = () => {
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: '50px',
          lineHeight: '50px',
          textIndent: '10px',
          borderBottom: '1px solid #ccc',
          color: '#fff',
          background: '#06789D',
          fontSize: 18,
          width: '100%',
        }}
      >
        Confirm
      </div>
    );
  };
  const DeleteClick = async () => {
    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();
    const params = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
        policies: {
          guaranteepolicy: [
            {
              guaranteeid: props.cancellationDetails.guaranteeid,
              guaranteelangid: props.cancellationDetails.guaranteelangid,
            },
          ],
        },
      },
    };
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${props.cancellationDetails.policyname} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: () => {
        setLoadinFlag(true);
        delPolicyGuaranteePayment(params).then(
          (res) => {
            setLoadinFlag(false);
            if (res.result.success) {
              //props.setActiveTabKey('GuaranteePayment')
              props.cancelEditable();
              props.getPoliciesData('GuaranteePayment');
            } else {
              message.error({
                content: 'operation failed',
              });
            }
          },
          (err) => {
            message.error({
              content:
                err?.message || err?.error[0]?.message || 'operation failed',
            });
            setLoadinFlag(false);
          }
        );
      },
      onCancel() {},
    });
  };
  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled);
      return;
    }
    if (activeTabKey === 'Detail') {
      detailEditRef.current.detailsForm.validateFields().then(
        (value: any) => {
          if (!dateValidation) {
            setDisabledStatus(false);
          } else {
            setDisabledStatus(true);
          }
        },
        (err: any) => {
          err.errorFields.length === 0 && !dateValidation
            ? setDisabledStatus(false)
            : setDisabledStatus(true);
        }
      );
    } else if (activeTabKey === 'PaymentAddress') {
      payAddEditRef.current.paymentAddressForm.validateFields().then(
        (value: any) => {
          setDisabledStatus(false);
        },
        (err: any) => {
          err.errorFields.length === 0
            ? setDisabledStatus(false)
            : setDisabledStatus(true);
        }
      );
    } else if (activeTabKey === 'AcceptedPayment') {
      accPayEditRef.current.aceeptedPaymentForm.validateFields().then(
        (value: any) => {
          setDisabledStatus(false);
        },
        (err: any) => {
          err.errorFields.length === 0
            ? setDisabledStatus(false)
            : setDisabledStatus(true);
        }
      );
    }
  };

  if (loadinFlag) return <Loading type="large" />;
  return (
    <>
      <Tabs defaultActiveKey={activeTabKey}>
        <TabPane
          tab="Detail"
          key="Detail"
          forceRender={true}
          disabled={eidtFlag}
        >
          {!eidtFlag ? (
            <DetailDetails
              cancellationDetails={rowEditData}
              toggleToEditMode={toggleToEditMode}
              setActiveTabKey={setActiveTabKey}
              changeTab={props.changeTab}
            />
          ) : (
            <DetailEdit
              payAddEditRef={payAddEditRef}
              accPayEditRef={accPayEditRef}
              className={styles.cardMargin}
              cancellationDetails={rowEditData}
              ref={detailEditRef}
              setValidateDate={setDateValidation}
              validateDate={dateValidation}
              validateFieldsError={validateFieldsError}
            />
          )}
        </TabPane>
        <TabPane
          tab="Accepted Payment"
          key="AcceptedPayment"
          forceRender={true}
          disabled={eidtFlag}
        >
          {!eidtFlag ? (
            <AcceptedPaymentDetails
              accPayEditRef={accPayEditRef}
              cancellationDetails={rowEditData}
              toggleToEditMode={toggleToEditMode}
              setActiveTabKey={setActiveTabKey}
              changeTab={props.changeTab}
            />
          ) : (
            <AcceptedPaymentEdit
              payAddEditRef={payAddEditRef}
              className={styles.cardMargin}
              cancellationDetails={rowEditData}
              ref={accPayEditRef}
              validateFieldsError={validateFieldsError}
            />
          )}
        </TabPane>
        <TabPane
          tab="Payment Address"
          key="PaymentAddress"
          forceRender={true}
          disabled={eidtFlag}
        >
          {!eidtFlag ? (
            <PaymentAddressDetails
              payAddEditRef={payAddEditRef}
              cancellationDetails={rowEditData}
              toggleToEditMode={toggleToEditMode}
              setActiveTabKey={setActiveTabKey}
              changeTab={props.changeTab}
            />
          ) : (
            <PaymentAddressEdit
              accPayEditRef={accPayEditRef}
              className={styles.cardMargin}
              cancellationDetails={rowEditData}
              ref={payAddEditRef}
              validateFieldsError={validateFieldsError}
            />
          )}
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onDelete={DeleteClick}
        onCancel={() => {
          props.cancelEditable();
          setEditFlag(false);
        }}
        onSave={addSave}
        disabledSave={disabledStatus}
        show={eidtFlag}
        warningMsg={true}
      />
    </>
  );
};
export default GPDetails;
